import styled from "styled-components";

export const Container = styled.div`
  border-bottom: ${props => props.theme.midGreyBorder};
`;

export const OrdersSection = styled.div`
  padding-top: 2rem;

  @media only screen and (min-width: ${props => props.theme.tablet}) {
    padding-top: 8rem;
  }
`;

export const OrdersSectionHeader = styled.div`
  margin-bottom: 3.2rem;

  @media only screen and (min-width: ${props => props.theme.tablet}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h2 {
    @media only screen and (min-width: ${props => props.theme.tablet}) {
      margin-bottom: 0;
    }
  }

  button {
    display: flex;
    align-items: center;
    font-family: AnPostSansBold, sans-serif;
    color: ${props => props.theme.lightGreen};
    position: relative;
    padding-right: 2.4rem;

    &:after,
    &:before {
      content: "";
      position: absolute;
      display: inline-block;
      width: 1.4rem;
      height: 0.2rem;
      border-radius: 0.2rem;
      background-color: ${props => props.theme.lightGreen};
      margin-left: 0.9rem;
      right: 0;
    }

    &:before {
      display: ${props => props.hiddenOrders ? "block" : "none"};
      transform: rotate(90deg);
    }
  }
`;

export const OrderCardWrapper = styled.div`
  display: ${props => props.hiddenOrders ? "none" : "block"};
  padding-bottom: 3.2rem;

  @media only screen and (min-width: ${props => props.theme.tablet}) {
    padding-bottom: 4rem;
  }

  button {
    width: 100%;
    margin-bottom: 1.2rem;
  }

  .cta-link {
    display: inline-block;
    color: ${props => props.theme.lightGreen};
    margin-top: 3.2rem;

    @media only screen and (min-width: ${props => props.theme.tablet}) {
      margin-top: 4rem;
    }
  }
`;

export const OrderCardGrid = styled.div`
  @media only screen and (min-width: ${props => props.theme.tablet}) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
    gap: 32px;
  }
`;

export const OrderCard = styled.div`
  display: none;
  flex-direction: column;
  border: ${props => props.theme.midGreyBorder};
  border-radius: 0.5rem;
  padding: 2rem;
  width: 100%;

  &:first-child {
    display: flex;
  }

  @media only screen and (min-width: ${props => props.theme.tablet}) {
    display: flex;
    width: auto;
  }
`;

export const OrderHeader = styled.div`
  margin-bottom: 1.6rem;

  @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2.4rem;
  }

  strong {
    font-size: 1.4rem;
  }
`;

export const OrderDate = styled.div`
  font-size: 1.4rem;
  margin-right: 1.6rem;
  margin-bottom: 1.6rem;

  @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
    margin-bottom: 0;
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 0.8rem;

  &:nth-child(2) {
    padding-top: 0.8rem;
    border-top: ${props => props.theme.midGreyBorder};
  } 
`;

export const ItemName = styled.div`
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
`;

export const ItemImage = styled.img`
  width: 4.8rem;
  height: 4.8rem;
  margin-right: 0.8rem;
  object-fit: contain;

  @media only screen and (min-width: ${props => props.theme.tablet}) {
    width: 6.4rem;
    height: 6.4rem;
    margin-right: 1.6rem;
  }
`;

export const ItemDetails = styled.div`
  span {
    font-size: 1.4rem;
  }
`;

export const Price = styled.span`
  font-family: Poppins, sans-serif;
  font-weight: ${props => (props.strikethrough ? "normal" : "bold")};
  color: ${(props) =>
    props.discount
      ? props.theme.red
      : props.strikethrough
      ? props.theme.lightGray2
      : props.theme.black};
  text-decoration: ${(props) => props.strikethrough ? "line-through" : "none"};
  margin-right: 1.6rem;
`;

export const ItemSummary = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.6rem;
  margin-top: auto;

  span {
    font-size: 1.4rem;
    color: ${props => props.theme.lightGray2};
    font-weight: bold;
  }
`;

export const TotalPrice = styled.div`
  font-family: AnPostSansBold, sans-serif;
  background-color: ${props => props.theme.lightGray};
  font-size: 1.6rem;
  padding: 0.8rem 1.6rem;
  margin-left: auto;
  margin-top: 1.6rem;

  @media only screen and (min-width: ${props => props.theme.tablet}) {
    font-size: 1.8rem;
    padding: 1.6rem;
  }
`;

export const DetailsLink = styled.a`
  font-family: AnPostSansBold, sans-serif;
  display: block;
  text-align: center;
  color: ${(props) => props.theme.lightGreen};
  text-decoration: none;
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;